import { render, staticRenderFns } from "./CardCommentsList.vue?vue&type=template&id=76638206&"
import script from "./CardCommentsList.vue?vue&type=script&lang=js&"
export * from "./CardCommentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports